import { BeneficiaryDetailsFormModel } from './beneficiary-details-form.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Beneficjent } from '../../../../models/beneficjent';
import { CzlonekRodziny } from '../../../../models/czlonek-rodziny';
import { SharedValidators } from '../../../../validators/shared-validators';
import { CustomValidatorsBeneficiaryDetails } from '../validators/custom-validators-beneficiary-details';
import { RodzajDokumentu } from '../../../../enums/rodzaj-dokumentu.enum';
import { DowodOsobistyValidator } from '../../../../validators/dowod-osobisty.validator';

export class BeneficiaryDetailsFormBuilder {
  public static createFormGroup(
    user?: Beneficjent | CzlonekRodziny,
  ): FormGroup<BeneficiaryDetailsFormModel> {
    const fg = new FormGroup<BeneficiaryDetailsFormModel>({
      id: new FormControl(user?.id || null),
      imie: new FormControl(user?.imie || null, [
        Validators.required,
        SharedValidators.doNotBeginWithWhitespace(),
        SharedValidators.imieNazwiskoValidator(),
      ]),
      drugieImie: new FormControl(user?.drugieImie || null, [
        SharedValidators.doNotBeginWithWhitespace(),
        SharedValidators.imieNazwiskoValidator(),
      ]),
      nazwisko: new FormControl(user?.nazwisko || null, [
        Validators.required,
        SharedValidators.doNotBeginWithWhitespace(),
        SharedValidators.imieNazwiskoValidator(),
      ]),
      obywatelstwo: new FormControl(user?.obywatelstwo || null, [
        Validators.required,
      ]),
      pesel: new FormControl(user?.pesel || null, [
        CustomValidatorsBeneficiaryDetails.peselValid,
      ]),
      dataUrodzenia: new FormControl(
        user?.dataUrodzenia ? new Date(user.dataUrodzenia) : null,
        [Validators.required],
      ),
      rodzajDokumentu: new FormControl(user?.rodzajDokumentu || null),
      nrDokumentu: new FormControl(user?.nrDokumentu || null, [
        Validators.maxLength(25),
        SharedValidators.doNotBeginWithWhitespace(),
      ]),
      plec: new FormControl(user?.plec || null, [Validators.required]),
      stanCywilny: new FormControl(user?.stanCywilny || null, [
        Validators.required,
      ]),
    });
    this.#setValidators(fg);
    return fg;
  }

  static #setValidators(fg: FormGroup<BeneficiaryDetailsFormModel>) {
    fg.controls.nrDokumentu.addValidators([
      SharedValidators.when(
        Validators.required,
        () => fg.controls.rodzajDokumentu.value !== null,
      ),
      SharedValidators.when(
        DowodOsobistyValidator.validNumberDokumentuTozsamosci,
        () =>
          fg.controls.rodzajDokumentu.value === RodzajDokumentu.DOWOD_OSOBISTY,
      ),
    ]);
    fg.controls.rodzajDokumentu.addValidators(
      SharedValidators.when(
        Validators.required,
        () => !!fg.controls.nrDokumentu.value,
      ),
    );
    fg.setValidators([
      SharedValidators.anyControlHasValueValidator(
        'peselOrDocumentRequired',
        fg.controls.pesel,
        fg.controls.rodzajDokumentu,
      ),
      CustomValidatorsBeneficiaryDetails.plecValidator,
      CustomValidatorsBeneficiaryDetails.stanCywilnyPlecValidator,
    ]);
  }
}
